var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 0.5H3C1.34369 0.50131 0.00130969 1.84369 0 3.5V21.5C0.00130969 23.1563 1.34369 24.4987 3 24.5H21C22.6563 24.4987 23.9987 23.1563 24 21.5V3.5C23.9987 1.84369 22.6563 0.50131 21 0.5V0.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.20855 18.2125C6.36804 18.3947 6.59822 18.4994 6.84036 18.5C6.87759 18.5 6.91478 18.4976 6.95169 18.4927L9.25142 18.1918C9.45956 18.1643 9.65288 18.0691 9.80151 17.9209L17.7303 9.99213C18.0899 9.63153 18.0899 9.04796 17.7303 8.68736L15.8126 6.76969C15.452 6.4101 14.8684 6.4101 14.5078 6.76969L6.57903 14.6984C6.4308 14.8471 6.33559 15.0404 6.30809 15.2485L6.00715 17.5482C5.97568 17.7883 6.04906 18.0303 6.20855 18.2125ZM7.22474 17.2751L7.4603 15.4744L15.1601 7.7747L16.7253 9.33986L9.02548 17.0396L7.22474 17.2751Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5357 11.9432C15.3804 11.9436 15.2313 11.8822 15.1213 11.7725L12.7264 9.37768C12.4976 9.14857 12.4978 8.77731 12.7269 8.54846C12.956 8.3196 13.3273 8.31981 13.5561 8.54893L15.9501 10.9428C16.1177 11.1104 16.1679 11.3625 16.0771 11.5815C15.9864 11.8004 15.7727 11.9432 15.5357 11.9432V11.9432Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.c9c606bcb6e9447f445adcfff9590dcb.svg";
export { ForwardRef as ReactComponent };